
















import { defineComponent, computed, onMounted } from '@vue/composition-api';
import Login from '@/renderer/components/login/components/index.vue';
import LoginAnimation from '@/renderer/components/login/components/loginAnimation.vue';
import user from '@/renderer/scripts/utils/user';
import { protocolUrlMap } from '@/common/constant';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
const doAsyn = require('@tencent/do-asyn');
export default defineComponent({
  components: {
    Login,
    LoginAnimation,
  },
  setup(props, context) {
    const vm = context.root;
    const store = context.root.$store;
    const showInMobile = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    const thisYear = new Date().getFullYear();

    const methods = {
      // 根据from跳转到web、pc
      jumpToLogin() {
        const { state, code } = vm.$route.query;
        if (!state || !code) return;
        const stateStr = state as string;
        const [prefix, tenantKey, type, from, custom_state] = stateStr.split('_');
        user.setLoginFrom(from);
        if (from === 'web') {
          dispatchRouter(
            {
              name: 'login',
              query: { code, state: `${prefix}_${tenantKey}_${type}`, path: custom_state },
            },
            'replace',
          );
        } else if (from === 'pc') {
          // pc端通过协议唤起网盘app
          const url = `${protocolUrlMap.yufuLogin}?code=${code}&state=${prefix}_${tenantKey}_${type}`;
          const frame = document.createElement('iframe');
          frame.src = url;
          frame.style.display = 'none';
          document.body.appendChild(frame);
        } else if (['android', 'ios'].includes(from)) {
          // 安卓、ios端内执行回调
          // @ts-ignore
          doAsyn.gj(() => {
            // @ts-ignore
            TcsJSBridge.invoke('yufuCallback', { code, state }, res => {
              logger.ui('移动端接收到idaas参数...');
            });
          });
        }
      },
    };
    onMounted(() => {
      methods.jumpToLogin();
    });
    return {
      thisYear,
      showInMobile,
      ...methods,
    };
  },
});
